import { CSSProperties, FC, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { NewsItem } from '../ui'

import styles from './style.m.less'
import { useTranslation } from 'react-i18next'
import useRequest, { RequestTypes } from '../hooks/useRequest'
import { Carousel, Spin } from 'antd'
import useGetFiles from '../hooks/useGetFiles'
import useWindowWidth from '../hooks/useWindowWidth'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

interface IOtherNews {
    title?: string
    style?: CSSProperties
    hasDescription?: boolean
}

const OtherNews: FC<IOtherNews> = ({
    title = 'newsAndEvents.otherNews',
    style = {},
    hasDescription = true,
}) => {
    const { t, i18n } = useTranslation()

    const navigate = useNavigate()
    const windowWidth = useWindowWidth()
    const isCarousel = windowWidth <= 1300
    const carouselRef = useRef<any>(null)

    const {
        files: otherNewsFiles,
        downloadFileList: downloadOtherFileList,
        loadingIds: otherNewsFilesLoadingIds,
    } = useGetFiles()
    const handleClickOtherNews = (id: string) => {
        navigate(`/news/${id}`)
    }

    const {
        fetch,
        result: otherNews,
        isLoading: newsLoading,
    } = useRequest({
        link: `/api/content/v1/news`,
        method: RequestTypes.post,
    })

    const getOtherNews = () => {
        const currentLanguage = () => {
            return i18n.language.toUpperCase().split('-')[0]
        }
        const req = {
            body: {
                limit: 3,
                // offset: 20,
                filters: {
                    text_filter: null, //Поиск текста по заголовку и контексту
                    ts_from: null, // "2021-09-07T00:00:00Z",
                    ts_to: '2100-01-01T00:00:00Z', // "2023-03-16T00:00:00Z",
                    news_type_id: 0, // Тип Все - 0, Новость - 1 (значение по умолчанию), Событие - 2
                    news_language: currentLanguage()
                },
                sort: {
                    type_id: 1, //Сортировка 1 - по Дате
                    is_descending: true, // false - ascending; true - descending
                },
            },
        }
        fetch(req)
    }

    useEffect(() => {
        getOtherNews()
    }, [])

    const dowloadAllDocs = () => {
        const imgIdsList = (otherNews?.news || []).map((el: any) => el.document.id)
        downloadOtherFileList(imgIdsList)
    }

    useEffect(() => {
        if (otherNews?.news) {
            dowloadAllDocs()
        }
    }, [otherNews])

    const renderNewsItem = (item: any) => (
        <NewsItem
            key={item.id}
            title={item.title}
            date={item.ts_created}
            isNews={item.news_type_id === 1}
            isEvent={item.news_type_id === 2}
            description={hasDescription ? item.body : ''}
            image={
                !otherNewsFiles[item.document.id] &&
                require('../../assets/images/newsBig.jpg')
            }
            fileLoading={otherNewsFilesLoadingIds[item.document.id]}
            file={
                item.document.id && otherNewsFiles[item.document.id]
            }
            onClick={() => handleClickOtherNews(item.id)}
        />
    )

    return (
        <div className={styles.newsOrEvent} style={style}>
            <div className={styles.container}>
                <Spin spinning={newsLoading}>
                    <div className={styles.otherNews}>
                        {title && <h2 className={styles.secondTitle}>{t(title)}</h2>}
                        <div className={styles.newsContainer}>
                            {isCarousel ? (
                                <div className={styles.carouselWrapper}>
                                    <button
                                        type="button"
                                        className={styles.carouselArrow + ' ' + styles.carouselArrowLeft}
                                        onClick={() => carouselRef.current?.prev()}
                                        aria-label="Previous"
                                    >
                                        <LeftOutlined />
                                    </button>
                                    <Carousel
                                        ref={carouselRef}
                                        dots={true}
                                        autoplay={true}
                                        className={styles.carousel}
                                    >
                                        {!newsLoading &&
                                            otherNews?.news?.map((item: any) => (
                                                <div key={item.id} className={styles.carouselSlide}>
                                                    {renderNewsItem(item)}
                                                </div>
                                            ))}
                                    </Carousel>
                                    <button
                                        type="button"
                                        className={styles.carouselArrow + ' ' + styles.carouselArrowRight}
                                        onClick={() => carouselRef.current?.next()}
                                        aria-label="Next"
                                    >
                                        <RightOutlined />
                                    </button>
                                </div>
                            ) : (
                                <div className={styles.grid}>
                                    {!newsLoading &&
                                        otherNews?.news?.map((item: any) => (
                                            <div key={item.id}>
                                                {renderNewsItem(item)}
                                            </div>
                                        ))}
                                </div>
                            )}
                        </div>
                    </div>
                </Spin>
            </div>
        </div>
    )
}

export default OtherNews
